import { useCallback } from 'react';
import { SerializedError } from '@reduxjs/toolkit';
import { ClientInteractionDetails } from '@common/model/stats/ClientInteractionDetails';
import { Result } from '@youhelp-ru/core';
import { ApiServerError } from '@cp/utils/rtk/query/model';
import { clientInteractionCoreApi } from 'src/entities/clientInteraction';

export const ACTION_FALLBACK_ERROR = 'Ошибка';

export const getActionErrorMessage = (error: SerializedError | ApiServerError | Error | undefined): string =>
  error?.message || ACTION_FALLBACK_ERROR;

/**
 * Loads interaction details for an action in the response-delay table.
 */
export const useInteractionDetails = (interactionId: number) => {
  const [load, { isLoading }] = clientInteractionCoreApi.endpoints.getDetails.useLazyQuery();

  const loadDetails = useCallback(async (): Promise<Result<ClientInteractionDetails, Error>> => {
    const result = await load({ id: interactionId });
    if (result.error) {
      return Result.Err(new Error(getActionErrorMessage(result.error)));
    }
    if (!result.data) {
      return Result.Err(new Error(ACTION_FALLBACK_ERROR));
    }
    return Result.Ok(result.data);
  }, [load, interactionId]);

  return { loadDetails, isLoading };
};
